import type { LatLng } from '@/types'

const EARTH_RADIUS_KM = 6371

/** Convert degrees to radians */
function toRad(deg: number): number {
  return (deg * Math.PI) / 180
}

/**
 * Calculate the great-circle distance between two points using the Haversine formula.
 * @returns Distance in kilometers
 */
export function haversineDistance(a: LatLng, b: LatLng): number {
  const dLat = toRad(b.lat - a.lat)
  const dLng = toRad(b.lng - a.lng)

  const halfSinLat = Math.sin(dLat / 2)
  const halfSinLng = Math.sin(dLng / 2)

  const h =
    halfSinLat * halfSinLat +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * halfSinLng * halfSinLng

  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h))
}
